import {Component, Input, OnInit} from '@angular/core';
import {DialerCall, DialerService} from '../dialer.service';
import {PhoneNumber, PhoneNumberService} from '../phone-number.service';
import {isNullOrUndefined} from 'util';
import {User, UserService} from '../user.service';
import {Observable} from 'rxjs/Observable';
import {NotificationService} from '../notification.service';

@Component({
  selector: 'app-dial-box',
  templateUrl: './dial-box.component.html',
  styleUrls: ['./dial-box.component.css']
})
export class DialBoxComponent implements OnInit {

  readonly actualSourceSK = 'ActualSource';

  @Input() callRequest: Observable<string>;

  // numberToDial: HTMLInputElement;
  numberToDial = '';
  invalidNumber = false;
  phones = new Array<PhoneNumber>();
  actualSource: PhoneNumber;

  disableDialButton = true;
  inCall = true;

  constructor(private ds: DialerService, private pns: PhoneNumberService, private us: UserService,
              private ns: NotificationService) {
  }

  ngOnInit() {
    this.ds.updateLastCall();
    this.us.currentUser.subscribe((currentUser: User) => {
      this.phones = currentUser.getPhones();
      if (this.phones.length > 0) {
        this.actualSource = this.getActualSource();
      }
      console.log(`actualSource:${JSON.stringify(this.actualSource)}`);
    });
    this.ds.actualCallSubject.subscribe((dc: DialerCall) => {
      if (isNullOrUndefined(dc)) {
        return;
      }
      this.setNumber(this.getPrettyNumber(dc.dstNumber.getE164Format()));
      this.disableDialButton = false;
      console.log(`DialerCallState: ${dc.state} =  DialerService.isCallFinished(dc)`);
      this.inCall = !dc.isFinished();
    });
    this.callRequest.subscribe((phoneNumber: string) => {
      if (this.inCall) {
        this.ns.error('É necessário finalizar a chamada atual!', 'Impossível realizar chamada');
      }else{
        this.tryToAct(phoneNumber);
      }
    });
  }

  numberChanged(event: any) {
    this.updateNumberValidity(event.target.value);
  }

  setNumber(num: string) {
    console.log(`setting numberToDial:${num}`);
    this.updateNumberValidity(num);
    this.numberToDial = num;
  }

  updateNumberValidity(num: string) {
    this.invalidNumber = (PhoneNumberService.parse(num, this.actualSource) === null);
  }

  getPrettyNumber(num: string): string {
    if (this.actualSource == null) {
      return '';
    } else {
      return this.pns.getBetterFormat(PhoneNumberService.parse(num, this.actualSource), this.actualSource.areaCode);
    }
  }

  setSource(source: string) {
    if (this.inCall === true) {
      console.log(`Impossible to set source in call, disconnect first!!!`);
      return;
    }
    localStorage.setItem(this.actualSourceSK, source);
    this.actualSource = this.getActualSource();
    console.log(`Setting actualSource to : ${this.actualSource}`);
  }

  tryToAct(number: string) {
    if (!this.inCall) {
      console.log(`Trying to dial ${this.getPrettyNumber(number)} to ${JSON.stringify(this.actualSource)}`);
      this.setNumber(this.getPrettyNumber(number));
      this.disableDialButton = true;
      this.ds.createCall(this.actualSource, PhoneNumberService.parse(number, this.actualSource));
    } else {
      console.log(`Call on course, trying to disconnect ${this.ds.actualCallSubject.getValue().id}`);
      this.disableDialButton = true;
      this.ds.hangupCall(this.ds.actualCallSubject.getValue().id).subscribe((s) => {
        if (s === 'ERROR') {
          console.log(`Error trying to hangup call`);
        } else {
          console.log(`Hangup Successful, id:${s}`);
        }
        this.disableDialButton = false;
      });
    }
  }

  getActualSource(): PhoneNumber {
    let phoneToSet: PhoneNumber = null;
    if (!isNullOrUndefined(localStorage.getItem(this.actualSourceSK))) {
      this.phones.map((p: PhoneNumber) => {
        if (p.description === localStorage.getItem(this.actualSourceSK)) {
          phoneToSet = p;
        }
      });
    } else {
      localStorage.setItem(this.actualSourceSK, this.phones[0].description);
      phoneToSet = this.phones[0];
    }
    if (phoneToSet == null) {
      localStorage.setItem(this.actualSourceSK, this.phones[0].description);
      return this.phones[0];
    }
    return phoneToSet;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/dial-box/dial-box.component.ts